/**
 * DevExtreme (esm/ui/list/modules/deleting.slideItem.js)
 * Version: 21.2.3
 * Build date: Thu Oct 28 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import "../ui.list.edit.decorator.switchable.slide";
